import BreadCumb from "../Components/Common/BreadCumb";
import PLD from "../Components/PLD/PLD";

const PLDPage = () => {
    return (
        <div>
            <BreadCumb
                bgimg="/assets/images/bg/breadcumgBg.png"
                Title="Prevenção à Lavagem de Dinheiro (PLD)"
            ></BreadCumb>
            <PLD></PLD>
        </div>
    );
};

export default PLDPage;
